import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { IconButton, Typography } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import i18n from '@shared/config/i18n';
import { DetailBreadcrumbs } from '@shared/ui/detail-breadcrumbs';
import { closeDetail } from '../../../../models';
import { $sduiTicketData, NEW_OPENED_ID } from '../../../../models/detail-sdui';
import { $openedId } from '../../../../models/detail-sdui-opened-id/model';
import {
  $relatedAvailable,
  setAddRelation,
  setIsBackConfirmDialogOpened,
} from '../../../../models/related-tickets';
import { Chats } from '../chats';
import * as Styled from './styled';

const { t } = i18n;

const getTicketTitle = (className: string) =>
  className === 'incident' ? t('Incident') : t('ClientTicket');

export const HeaderRelatedTickets = () => {
  const [sduiTicketData, relatedAvailable] = useUnit([
    $sduiTicketData,
    $relatedAvailable,
  ]);

  const clientTicket = `${getTicketTitle(sduiTicketData.class)} № ${sduiTicketData.number ?? ''}`;

  const closeFunc = () => {
    if (!relatedAvailable.length) {
      setAddRelation(false);

      return;
    }

    setIsBackConfirmDialogOpened(true);
  };

  return (
    <Styled.Horizontal>
      <Styled.Left>
        <DetailBreadcrumbs
          secondaryText={clientTicket}
          primaryText={t('ContactingApplications')}
          onBack={closeFunc}
          title={t('AddingAConnection')}
        />
      </Styled.Left>

      <Styled.Right>
        <IconButton onClick={closeFunc}>
          <CloseOutlinedIcon />
        </IconButton>
      </Styled.Right>
    </Styled.Horizontal>
  );
};

export const HeaderSdui = ({ isIncident }: { isIncident?: boolean }) => {
  const [openedId, sduiTicketData] = useUnit([$openedId, $sduiTicketData]);

  const clientTicket = `${getTicketTitle(sduiTicketData.class)} № ${sduiTicketData.number ?? ''}`;

  const channels = useMemo(
    () => sduiTicketData.channels,
    [JSON.stringify(sduiTicketData.channels)]
  );

  return (
    <Styled.Horizontal>
      <Styled.Left>
        <Typography variant="h6">
          {openedId === NEW_OPENED_ID ? t('NewTicket') : clientTicket}
        </Typography>
      </Styled.Left>

      <Styled.Right>
        {openedId && openedId !== NEW_OPENED_ID && !isIncident && (
          <Chats channels={channels} />
        )}

        <IconButton onClick={() => closeDetail()}>
          <CloseOutlinedIcon />
        </IconButton>
      </Styled.Right>
    </Styled.Horizontal>
  );
};
